import { render, staticRenderFns } from "./AvatarFeedback.vue?vue&type=template&id=e8d92ae8&scoped=true&"
import script from "./AvatarFeedback.vue?vue&type=script&setup=true&lang=js&"
export * from "./AvatarFeedback.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d92ae8",
  null
  
)

export default component.exports